import { render, staticRenderFns } from "./Garden.vue?vue&type=template&id=80160be0&scoped=true"
import script from "./Garden.vue?vue&type=script&lang=js"
export * from "./Garden.vue?vue&type=script&lang=js"
import style0 from "./Garden.vue?vue&type=style&index=0&id=80160be0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80160be0",
  null
  
)

export default component.exports